import Vue from 'vue';
// @ts-ignore
import VueMask from 'v-mask';

Vue.use(VueMask);
